import _ from 'lodash';

export const vehicleAdapter = (vincheck) => {
  const vehicle = _.get(vincheck, 'vehicle', null);
  _.set(vehicle, 'registration', _.get(vincheck, 'registration', null));
  _.set(vehicle, 'mileage', _.get(vincheck, 'mileage', null));
  delete vehicle.versions;
  delete vehicle.equipments;
  return vehicle;
};
